import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { InfoNav } from "./Nav"; // Update this import path to point to your InfoNav
import { fetchData, getPageHeader } from "../utils/apiServices";

export default function StudentInfo({ instDetails }) {
    const [loading, setLoading] = useState(true);

    const [pageHeader, setPageHeader] = useState(null);

    useEffect(() => {
        (async () => {
            setLoading(true);

            const fetchedPageHeader = await getPageHeader({ pageName: "StudentInfo" });
            setPageHeader(fetchedPageHeader);

            setLoading(false);
        })();
    }, []);
    return (
        <div className="my-4">
            <div className="d-flex justify-content-between my-auto align-items-sm-start align-items-md-center">
                <h2 className="no-print">{pageHeader}</h2>
                <div className="d-flex flex-wrap btn-group justify-content-end mb-3 no-print">
                    <InfoNav homePageUrl={instDetails?.homePageUrl} />
                </div>
            </div>

            <div className="">
                <Outlet />
            </div>
        </div>
    );
}